import { CA } from "@/config";

export const copyCa = () => {
  if (CA) {
    navigator.clipboard?.writeText(CA);
    return true;
  }
  return false;
};

export const shortCa = () =>
  CA ? `${CA.slice(0, 6)}…${CA.slice(-4)}` : "";
